export const convertChartSelectedLegendToFilters = (selected = {}) => {
  if (!selected) return [];

  const allSelected = !Object.values(selected).includes(false);

  if (allSelected) return [];

  return Object.entries(selected)
    .map(([filterName, isSelected]) => (isSelected ? filterName : undefined))
    .filter((value) => value !== undefined);
};

export const convertFiltersToChartSelectedLegend = (
  legendKeys = [],
  filters = []
) => {
  const allSelected = filters?.length ? false : true;

  // https://echarts.apache.org/handbook/en/concepts/legend
  return (legendKeys ?? []).reduce(
    (selectedLegend, key) => ({
      ...selectedLegend,
      [key]: allSelected ? true : filters.includes(key),
    }),
    {}
  );
};
